import React from "react";
import PropTypes from "prop-types";
import Modal from "@shared/v2/Modal";
import Button from "@shared/v2/Button";
import DatePicker from "../../../shared/DatePicker";

const Reschedule = ({
  closeModal,
  rescheduleDate,
  rescheduleDateHandler,
  rescheduleTasksHandler,
  submitDisabled,
  taskCount,
}) => (
  <Modal
    id="reschedule-task-modal"
    show
    onHide={closeModal}
    dialogClassName="tw-flex tw-items-center tw-justify-center tw-h-full"
    contentClassName="tw-max-w-[640px] tw-max-h-[90vh] tw-w-full tw-flex tw-flex-col tw-gap-[32px]"
  >
    <Modal.Header
      title={`Hey! You're about to reschedule ${taskCount} task${taskCount > 1 ? "s" : ""}!`}
      description="Don't worry, your client doesn't see when you reschedule something. Select how far you want to move these dates around."
      closeModal={closeModal}
    />

    <Modal.Body className="tw-flex">
      <DatePicker
        className="tw-basis-1/2"
        timeFormat={false}
        dateFormat="MM-DD-YYYY"
        name="reschedule_date"
        value={rescheduleDate}
        onChange={rescheduleDateHandler}
      />
    </Modal.Body>

    <Modal.Footer className="tw-flex tw-justify-between tw-gap-[16px]">
      <Button schema="tertiary" size="medium" onClick={closeModal}>
        Cancel
      </Button>
      <Button size="medium" isLoading={submitDisabled} onClick={rescheduleTasksHandler}>
        Reschedule
      </Button>
    </Modal.Footer>
  </Modal>
);

Reschedule.propTypes = {
  closeModal: PropTypes.func.isRequired,
  rescheduleDate: PropTypes.string.isRequired,
  rescheduleDateHandler: PropTypes.func.isRequired,
  rescheduleTasksHandler: PropTypes.func.isRequired,
  submitDisabled: PropTypes.bool.isRequired,
  taskCount: PropTypes.number.isRequired,
};

export default Reschedule;
